import { STATUS_TYPE } from '../../../enum';


export interface TotalOrder {
  count: number;
  date: string;
}

export interface TotalSales {
  sale: number;
  date: string;
}

export interface FindDashboardReport {
  timePeriod: string;
  startDate?: string;
  endDate?: string;
}

export interface DashboardReport {
  totalOrders: TotalOrder[];
  totalSales: TotalSales[];
  averageOrderValue: number;
  averageDailyOrders: number;
  averageDailySales: number;
}

export interface InitialState {
  data: DashboardReport | null;
  skip: number;
  limit: number;
  totalRecords: number;
  currentPage: number;
  status: STATUS_TYPE;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  errorMessage: string;
}

export const initialState: InitialState = {
  data: null,
  skip: 0,
  limit: 5,
  totalRecords: 0,
  currentPage: 0,
  status: 'idle',
  isError: false,
  isLoading: false,
  isSuccess: false,
  errorMessage: '',
};